/**
 * Validates and formats a date value for AWS GraphQL AWSDate type (YYYY-MM-DD)
 * @param {string|Date|null|undefined} dateValue - The date value to format
 * @returns {string|null} The formatted date string (YYYY-MM-DD) or null if invalid
 */
export const formatAWSDate = (dateValue) => {
  if (!dateValue) return null;
  
  // If it's already a valid date string (YYYY-MM-DD), return it
  if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  }
  
  // Try to parse as Date and format
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return null;
    return date.toISOString().substring(0, 10);
  } catch {
    return null;
  }
};
